import { Helmet } from 'react-helmet';
import { HealthProfessionEditContainer } from '../components/health-profession-edit.container';

export const ISConfigHealthProfession: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Is config - Health Professions</title>
      </Helmet>
      <HealthProfessionEditContainer />
    </>
  );
};
